import { NotificationType } from "./Notification";

export class GeneralSettings{
    isOnlineMode: boolean;
    sessionTimeout: string;
    helpURL: string;
    defaultHelpURL: string;
    isDefaultDBPwdChanged: boolean;
    isNTLMProxy: boolean;
}

export class LogsSettings {
    httpLogLevel: string;
    logLevel: string;
    requestLog: boolean;
    requestLogRetainDays: number;
    SFTPLogLevel: string;
}

export class ProxySettings {
    authType: string;
    isProxyMode: boolean;
    nonProxyServerUrls: string;
    password: string;
    passwordRequired: boolean;
    port: string;
    serverUrl: string;
    storeCredentials: boolean;
    username: string;
}

export class NotificationSettings {
    purge: boolean;
    days: number;
    types: NotificationType[];
    selected: string[];
    purgeNow: boolean;
}

export class ExternalVendorFileSettings {
    useRestrictions: boolean;
    defaultMaxFileCount: number;
    maxFileCount: number;
    defaultMaxFileSize: number;
    maxFileSize: number;
    defaultMaxDiskSpace: number;
    maxDiskSpace: number;
    allowedExtensions: string[];
}

export class ActivitySettings {
    enableRetryOnError: boolean;
    enableRetryOnErrorPeriod: number;
}

export class DatabaseConfigRequest {
    currentPassword: string;
    newPassword: string;

    constructor(currentPassword: string, newPassword: string){
        this.currentPassword = currentPassword;
        this.newPassword = newPassword;
    }
}